(function () {
	'use strict';

	a3_cabin_reports.directive('mainFooter', mainFooter);

	/**
	  * @memberof CabinReports
	  * @ngdoc directive
	  * @name mainFooter
	  * @restrict E
	  * @description
	  *   Implementation of mainFooter
	  *   Initialize The main Footer Template and its Navigation, Sync, Footer Functionality
	  * @example
	  *   Usage:
	  *   <main-footer></main-footer>
	  * @ngInject 
	  */
	function mainFooter($location, SettingsMain, UserFactory, $uibModal, MessageFactory, DataCleanerFactory, $route, MemoFactory, FaqFactory, RequestFactory, $sce, $timeout, FlightFactory, LeaveRequestFactory, PassengerMealServiceFactory) {
		/**
		 * Initialize mainFooter and events
		 * @memberof mainFooter
		 * @param {service} scope the scope of this element
		 * @param {service} element element that this direcive is assigned to
		 * @param {service} attrs attribute of this element
		 */
		function link(scope, element, attrs) {

			var messagesCount = 0;
			var messages = [];
			var unreadMessagesCount = 0;
			var memosCount = 0;
			var memos = [];
			var faqs = [];
			var newFAQCount = 0;
			var updatedFAQCount = 0;

			/**
			 * Open a modal from which u can Logout from the application
			 * @memberof mainFooter  
			 */
			function logout() {
				var isSecure = UserFactory.isSecure()
				bootbox.dialog({
					message: (isSecure ?
						"<strong class='text-danger'>Due to the fact that you are working over a public computer, all stored data will be deleted on logout!</strong><br/><br/>" :
						"You will be able to login again into the same account, even if there is no internet access.<br/><br/>") +
						"Please confirm that you wish to log out.",
					title: "<strong>User Logout<strong>",
					buttons: {
						cancel: {
							label: "Cancel",
							className: "btn-default",
							callback: function () { }
						},
						logout: {
							label: "Logout",
							className: "btn-warning",
							callback: function () {
								UserFactory.clearActiveUser();
								if (isSecure) DataCleanerFactory.deleteAllData();

								UserFactory.azSignOut();
								location.reload(true);
								// need to reload, in order for the
								// browser to check the cache.manifest
								// and discover any changes
							}
						}
					}
				});
			}

			/**
			 * Redirects to Reset Device View
			 * @memberof mainFooter  
			 */
			function resetDevice() {
				$location.path("/reset");
			}

			/**
			 * Open a modal from which you can delete all available reports
			 * @memberof mainFooter  
			 * @method
			 */
			function deleteAllReports() {
				bootbox.dialog({
					message: "Use this process to clear your device from all locally stored Cabin Reports, in order to save up space, when available storage space is not sufficient for the application to function properly.<br/><br/>" +
						"<h4>ATTENTION</h4>" +
						"This action will delete all Cabin Reports from your device, <span style='text-decoration: underline;'>including draft and completed ones not sent to the server</span>.",
					title: "<strong>Application Logs Reset<strong>",
					buttons: {
						cancel: {
							label: "Cancel",
							className: "btn-default",
							callback: function () { }
						},
						danger: {
							label: "Delete All Cabin Reports",
							className: "btn-danger",
							callback: function () {
								DataCleanerFactory.deleteAllReports();
								$route.reload();
								bootbox.alert("All Cabin Reports have been successfully deleted.", function () { });
							}
						}
					}
				});
			}

			/**
			 * Navigate to Calendar View
			 * @memberof mainFooter  
			 */
			function gotoCalendar() {
				SettingsMain.setEditingPage(null);
				// go to dashboard
				$location.path("/");
			}

			/**
			 * Navigate to Submit ticket view
			 * @memberof mainFooter  
			 */
			function gotoTicket() {
				// go to Submit ticket view
				$location.path("/ticket");
			}

			/**
			 * Navigate to Messages View
			 * @memberof mainFooter  
			 */
			function gotoMessageLibrary() {
				$location.path('/messages');
			}

			/**
			 * Navigate to Memos Library
			 * @memberof mainFooter  
			 */
			function gotoMemos() {
				$location.path('/memos');
			}
			/**
				* Navigate to Bucket
				* @memberof mainFooter  
				*/
			function gotoBucketCalendar() {
				$location.path('/bucket');
			}

			/**
			 * Navigate to FAQs View
			 * @memberof mainFooter  
			 */
			function gotoFAQs() {
				$location.path('/faqs');
			}

			/**
			 * Navigate to Roster Requests View
			 * @memberof mainFooter  
			 */
			function gotoRequests() {
				$location.path("/rosterRequests");
			}

			/**
			 * Navigate to FAQs View
			 * @memberof mainFooter  
			 */
			function gotoLeaveRequests() {
				$location.path('/leaverequest');
			}

			function gotoMealLibrary() {
				$location.path('/mealLibrary');
			}

			function gotoCrewExpiries() {
				$location.path('/crewExpiries');
			}
			
			/**
			 * Open the "Search Flight Info" Modal
			 * @memberof CalendarCtrl
			 */
			function openSearchFlightsModal() {
				var modalInstance = $uibModal.open({
					templateUrl: './views/SearchFlights/dlgSearchFlights.html',
					controller: 'SearchFlightsCtrl',
					size: 'md',
					backdrop: 'static',
					keyboard: false
				});
			}


			messages = MessageFactory.getMessagesFromStorage();
			messagesCount = messages.length;
			for (var i = 0; i < messages.length; i++) {
				if (messages[i].ReadDt == null) {
					unreadMessagesCount++
				}
			}

			MemoFactory.getNotHiddenMemos(function (results) {
				scope.memosCount = results.length;
			});

			faqs = FaqFactory.getFAQsFromStorage();
			for (var i = 0; i < faqs.length; i++) {
				if (faqs[i].newItems) {
					newFAQCount += faqs[i].newItems;
				}
				if (faqs[i].updatedItems) {
					updatedFAQCount += faqs[i].updatedItems;
				}
			}

			scope.messagesCount = messagesCount;
			scope.unreadMessagesCount = unreadMessagesCount;
			scope.logout = logout;
			scope.resetDevice = resetDevice;
			scope.deleteAllReports = deleteAllReports;
			scope.gotoMessageLibrary = gotoMessageLibrary;
			scope.gotoMemos = gotoMemos;
			scope.gotoBucketCalendar = gotoBucketCalendar;
			scope.memosCount = memosCount;
			scope.gotoFAQs = gotoFAQs;
			scope.gotoRequests = gotoRequests;
			scope.gotoLeaveRequests = gotoLeaveRequests;
			scope.newFAQCount = newFAQCount;
			scope.updatedFAQCount = updatedFAQCount;
			scope.gotoCalendar = gotoCalendar;
			scope.showPopover = false;
			scope.gotoTicket = gotoTicket;
			scope.leaveRequestInformation = LeaveRequestFactory.getLeaveRequestInformation();
			scope.openSearchFlightsModal = openSearchFlightsModal;
			scope.gotoMealLibrary = gotoMealLibrary;
			scope.gotoCrewExpiries = gotoCrewExpiries;
		}

		return {
			restrict: 'E',
			terminal: true,
			templateUrl: "views/Main/footer.tpl.html",
			scope: false,
			link: link
		}
	}

})();